export default __webpack_public_path__ + "static/scheduled-flag-changes-light-d03cd3d0fed19e40c8ad6e5d1e3d9865.png";